export default "<mat-spinner  [diameter]=\"50\" style=\"margin: 0 auto;\"></mat-spinner>\n<span>{{data.message}}</span> ";